export default __webpack_public_path__ + "static/media/IconBlue.4ec15067.svg";